import ApiService from './ApiService';

export default class AuthApi extends ApiService {
    login(payload) {
        return this.post('login', payload);
    }

    logout() {
        return this.post('logout');
    }

    getProfile() {
        return this.get('profile');
    }

    registerEmail(payload) {
        return this.post('register-email', payload);
    }

    getUserByUUID(payload) {
        let { uuid } = payload;
        return this.get(`${uuid}/infor`);
    }

    registerUserInfor(payload) {
        return this.post('register-infor', payload);
    }

    forgotPassword(payload) {
        return this.post('forget-password', payload);
    }

    getCheckUuidConfirmPassword(payload) {
        const { uuid } = payload;
        return this.get('check-uuid', { uuid });
    }

    confirmPassword(payload) {
        return this.post('confirm-password', payload);
    }

    changePassword(payload) {
        return this.put('change-password', payload);
    }

    verifyChangeEmail(params) {
        return this.get('verify-new-email', params);
    }

    loginSSO(payload) {
        return this.post('login-sso', payload);
    }
}
